import {Image,Layout,Input,message,Button,Row,Col,Popconfirm,Upload,Breadcrumb,ConfigProvider,Pagination,Table,Modal,Switch} from 'antd'
import { Content } from 'antd/lib/layout/layout'
import OAMSider from '../oam-sider'
import {UploadOutlined, SearchOutlined} from '@ant-design/icons'
import React, { useEffect, useRef, useState } from 'react'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'
import myStyles from './oam-report-node.module.less'
import Draggable from 'react-draggable'
import idataCodingTableStyles from '../../common/global-styles/idatacoding.module.less'
import 'easymde/dist/easymde.min.css'
import zhCN from 'antd/lib/locale/zh_CN'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import * as constants from '../../../constants/constants'
import DeleteOutlined from '@ant-design/icons/lib/icons/DeleteOutlined'
import MarkDownEditor from '@/pages/components/MarkdownEditor/MarkdownEditor'
import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '@/constants/constants'

import {CloseOutlined} from '@ant-design/icons';

const { TextArea } = Input

export interface Props {}
export interface Props2 {}

const taskTypeMap = new Map([
  [1, '实训'],
  [6, '纯讲义'],
])
export const OAMReportNodeEdit: React.FC<Props> = (props) => {
  const nodeId = parseInt(window.location.search.split('=')[1]) // 节点的ID
  const [node, setNode] = useState(null as any) // 节点对象
  const [name, setName] = useState(null as any) // 节点名称
  const [description, setDescription] = useState(null as any) // 节点描述文本
  const [images, setImages] = useState([] as any[]) // 节点说明图片
  const [nodeTaskId, setNodeTaskId] = useState(null as any) // 节点绑定的任务ID
  const [nodeTaskTitle, setNodeTaskTitle] = useState(null as any) // 节点绑定的任务名称

  const selectedTask = useRef(null as any) //记录当前选择的任务

  const [userInputGuide, setUserInputGuide] = useState(null as any) // 用户输入引导文字
  const [userInputGuideAnswer, setUserInputGuideAnswer] = useState(null as any) // 用户输入引导参考答案

  const [taskListResult, setTaskListResult] = useState([] as any[]) // 当前显示的任务搜索
  const [taskResultSum, setTaskResultSum] = useState(0) // 搜索返回的任务结果数
  const [totalTaskCount, setTotalTaskCount] = useState(0) // 搜索返回的总任务结果数
  const queryTaskContent = useRef('') // 记录任务搜索串
  const queryTaskSource = useRef('2') // 来源 1-个人  2-OAM创建（系统）
  const taskOrder = useRef('') // 排序升序降序
  const taskOrderBy = useRef('') // 排序列
  const taskPage = useRef(1) // 记录当前的页数
  const taskPageSize = useRef(10) // 记录当前每页展示数量
  const typeFilters = useRef([]) // 类型过滤选项

  const [switchChecked, setSwitchChecked] = useState(false) //是否需要用户引导


  // 选择题默认选项
  const [isAddTaskModalVisible, setIsAddTaskModalVisible] = useState(false)

  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  useEffect(() => {
    queryNodeInfo()
    queryTaskList()
  }, [])

  /** 选择了任务*/
  const rowTaskSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      selectedTask.current = selectedRows[0]

      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        'selectedRows: ',
        selectedRows
      )
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.id == nodeTaskId,
    }),
  }

  // 查询任务详情
  const queryNodeInfo = () => {
    sendHttpPostRequest(
      'report/api/oam_query_node_by_id/',
      { node_id: nodeId, sessionid: Cookies.get('sessionid') },
      (response) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_report_node'
        } else if (response.is_ok == true) {
          // 成功
          setNode(response.query_info)
          setName(response.query_info?.name)
          setDescription(
            response.query_info?.description == ''
              ? ' '
              : response.query_info?.description
          )
          setImages(response.query_info?.images)
          setNodeTaskId(response.query_info?.exercise_id)
          setNodeTaskTitle(response.query_info?.exercise_title)
          setUserInputGuide(response.query_info?.input_info)
          setUserInputGuideAnswer(response.query_info?.answer_input_content)
          setSwitchChecked(response.query_info?.need_input_info == 2 ? true : false)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_report_node'
        } else {
          message.error(response.message)
        }
      }
    )
  }


  const onSwitchChange = (checked: boolean) => {
   setSwitchChecked(checked)
  }

  /**
   * 查询任务列表
   */
  const queryTaskList = () => {
    sendHttpPostRequest(
      'exercise/api/oam_query_exercise_list/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),

        query_type: 1,
        query: queryTaskContent.current,
        page: taskPage.current,
        pagesize: taskPageSize.current,
        order: taskOrder.current,
        order_by: taskOrderBy.current,
        type: JSON.stringify(typeFilters.current),
        source: queryTaskSource.current,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_task'
        } else if (response.is_ok == true) {
          // 成功
          setTaskListResult(response.exercise_list)
          setTaskResultSum(response.total_sum)
          setTotalTaskCount(response.total_count)
        } else {
          message.error('查询任务失败~')
        }
      }
    )
  }

  //点击了搜索按钮
  const onSearchTaskBtn = (e: any) => {
    taskPage.current = 1
    queryTaskContent.current = e.target.value
    queryTaskList()
  }

  // 表格发生变化
  const onTaskTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      taskOrder.current = sorter.order
      taskOrderBy.current = sorter.field
    }
    if (filters.type) {
      //如果选择了过滤列
      typeFilters.current = filters.type
    } else {
      typeFilters.current = []
    }
    taskPage.current = 1
    queryTaskList()
  }

  //页码和页数发生了变化
  const onTaskPageChange = (
    newPage: number,
    newPageSize?: number | undefined
  ) => {
    taskPage.current = newPage ? newPage : 1
    if (newPageSize) {
      taskPageSize.current = newPageSize
    }
    queryTaskList()
  }

  // 渲染类型
  const renderType = (text: any, record: any) => (
    <div>{taskTypeMap.get(parseInt(text))}</div>
  )


  // 上传报告节点图片的参数
  const uploadOption = {
    name: 'image',
    actionUrl: 'report/api/oam_upload_node_image/',
    uploadData: { sessionid: Cookies.get('sessionid'),
                node_id: nodeId,
              },
  }

  // 渲染操作
  const renderActions = (text:any, record:any) => {

    return <Row justify="start" align="middle" gutter={[8, 4]} >
            <Col span={24}>
            <Button style={{borderRadius:20,fontSize:14, margin:0, width:60}} 
            size='small' id="lookover" value={record.id} type="default" onClick={onLookOverTaskBtnClick.bind(this, record.id)} > 查 看 </Button></Col>
        </Row>
  }

  const task_columns: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 50,
    },
    {
      title: '任务名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      align: 'left',
      width: 150,
    },
    {
      title: '备注',
      dataIndex: 'remarks',
      key: 'remarks',
      align: 'center',
      width: 100,
      ellipsis: true,
    },
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      width: 120,
      align: 'left',
      render: (t, r, i) => {
        return (
          <Row align="middle" justify="start" style={{ gap: '5px' }}>
            <Col>
              <img
                className={GlobalCss.avatar}
                src={BACKEND_API_URL + r.creator_avatar}
                alt=""
              />
            </Col>
            <Col>{r.creator_name}</Col>
          </Row>
        )
      },
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 150,
      ellipsis: true,

    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      ellipsis: true,
      width: 60,
      render: renderType,
      filters: [
        {
          text: '实训',
          value: 1,
        },

        {
          text: '讲义',
          value: 6,
        },
      ],
      onFilter: (value: any, record: any) => true,
    },
    {
      title: "操作",
      dataIndex: "actions",
      key: "actions",
      width: 80,
      ellipsis: false,
      align: 'center',
      render: renderActions ,
  },

  ]

    // 点了查看 任务 按钮
    const onLookOverTaskBtnClick = (id:any, event: any) => {
      window.open(`/oam_preview_task?task_id=${id}`);
  }

  // 保存节点
  const saveNode = (key: any) => {
    message.destroy()
    const requestParams = {
      sessionid: Cookies.get('sessionid'),
      sid: Cookies.get('sessionid'),
      node_id: node?.id,
      name: name,
      description: description,
      exercise_id: nodeTaskId,
      //result_type: nodeTaskType,
      input_info: userInputGuide,
      answer_input_content: userInputGuideAnswer,
      need_input_info: switchChecked == true ? 2: 1,
      //images: JSON.stringify(images),
    }
    sendHttpPostRequest(
      'report/api/oam_update_node/',
      requestParams,
      (response: any) => {
        if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_report_node'
        } else if (response.is_ok == true) {
          // 成功
          message.success('报告节点保存成功~')
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_report_node'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 上传数据集传参
  const uploadData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
    node_id: nodeId,
  }

  // 上传图片
  const uploadImageProps = {
    accept: '.png,.jpg,.gif,.jpeg,',
    name: 'picture',
    multiple: false,
    showUploadList: false,
    data: uploadData,
    action: constants.BACKEND_API_URL + 'report/api/upload_node_image/',
    onChange(info) {
      const { status } = info.file
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        if (info.file.response.is_ok) {
          message.success(`图片${info.file.name}文件上传成功！`)
          if (!info.file.response.update_only) {
            images.push({
              name: info.file.response.image_name,
              url:
                info.file.response.image_path + info.file.response.image_name,
            })
            setImages(JSON.parse(JSON.stringify(images)))
          }
        } else {
          if (info.file.response.code == -100) {
            // 未登录
            const localPath = window.location.href.split(
              window.location.host
            )[1]
            window.location.href = `/oam_login?next=${localPath}`
          } else if (info.file.response.code == -501) {
            // 权限不足
            const localPath = window.location.href.split(
              window.location.host
            )[1]
            window.location.href = `/oam_login?next=${localPath}`
          } else {
            message.error(info.file.response.message)
          }
        }
      } else if (status === 'error') {
        message.error(`图片${info.file.name}文件上传失败了:(`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
  }

  // 删除图片回调
  const deleteImageCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      const localPath = window.location.href.split(window.location.host)[1]
      window.location.href = `/oam_login?next=${localPath}`
    } else if (response.code == -501) {
      // 权限不足
      const localPath = window.location.href.split(window.location.host)[1]
      window.location.href = `/oam_login?next=${localPath}`
    } else if (response.code == 0) {
      message.success(`图片${response.image_name}删除成功！`)
      const newImages = images.filter(
        (item) => item.name !== response.image_name
      )
      setImages(newImages)
    } else {
      message.error(response.message)
    }
  }


  /** 节点说明变化 */
  const onEditMDChange = (value: any) => {
    setDescription(value.text)
  }

  // 删除图片
  const deleteImage = (imageName: string, event: any) => {
    sendHttpPostRequest(
      'report/api/delete_node_image/',
      {
        sessionid: Cookies.get('sessionid'),
        node_id: nodeId,
        image_name: imageName,
      },
      deleteImageCallback
    )
  }

  const handleAddTaskOk = () => {
    setIsAddTaskModalVisible(false)
    setNodeTaskId(selectedTask.current?.id)
    setNodeTaskTitle(selectedTask.current?.title)
  }

  const handleAddTaskCancel = () => {
    setIsAddTaskModalVisible(false)
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={['10']} openKeys={['sub-report']} />

      <Content
        style={{
          backgroundColor: '#fff',
          borderRadius: 5,
          minWidth: 500,
          margin: 50,
          paddingTop: 20,
        }}
      >
        <Breadcrumb style={{ marginLeft: 0, float: 'left', marginTop: -50 }}>
          <Breadcrumb.Item>
            <a href="/oam_report_node">节点列表</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span style={{ fontWeight: 500 }}> 节点编辑 </span>
          </Breadcrumb.Item>
        </Breadcrumb>

        <div className={'css.search1'}
          style={{
            paddingTop: 20,
            paddingLeft: 50,
            paddingRight: 50,
            position: 'relative',
          }}
        >
          <Row gutter={[8, 8]} justify="start" align="middle" style={{ marginTop: -10, marginBottom: 10 }}>
            <Col style={{ marginTop: -10, textAlign: 'right' }} span={24}>
              <Button
                type="primary"
                style={{ width: 80, borderRadius: 20 }}
                onClick={saveNode}
              >
                保存
              </Button>
            </Col>
          </Row>
          <div style={{ padding: 20, borderRadius: 6}}>
            <Row gutter={[8, 8]} justify="start" align="middle" style={{ marginBottom: 20 }}>
              <Col flex="100px" style={{ color: '#00000073', textAlign: 'left' }}>节点名称</Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input placeholder="请输入节点名称" value={name}
                  onChange={(e) => { setName(e.target.value)}}
                  style={{ width: 400, borderRadius: 3 }}
                />
              </Col>
              <Col flex="200px"></Col>
            </Row>

            <Row gutter={[8, 8]} justify="start" align="middle" style={{ marginBottom: 10 }}>
              <Col flex="100px" style={{ color: '#00000073', textAlign: 'left' }}> 节点任务</Col>
              {nodeTaskId == 0 &&  <Col flex="auto" style={{ textAlign: 'left' }}>
                <Button style={{ width: 400, height: 32, background:'#FFFFFF', borderRadius:3, border:'1px solid'}}  type="default" onClick={() => { setIsAddTaskModalVisible(true)}}> 选择任务 </Button>
              </Col> }


              {nodeTaskId != 0 &&  
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <span style={{verticalAlign:'bottom' , color:'#3d6b74', background:'#E6ECED', borderRadius:3, display:'inline-block', height:32, width:320}}>
                  <span title={String(nodeTaskId) + ' ' + node?.exercise_title}  style={{ padding:'5px 10px', overflow:'hidden', whiteSpace: 'nowrap', display:'inline-block', textOverflow:"ellipsis", width:280}}> {nodeTaskId} {' '} {node?.exercise_title} </span>
                  <span  className = {myStyles.deleteNodeBtnWrapper} style={{marginLeft:20, position:'absolute', top:6}} onClick={() => { setNodeTaskId(0)}} > 
                    <CloseOutlined style={{height:10, width:10}}/>
                  </span>
                </span>
                 <Button 
                 style={{width:64, height:32, background: '#fff',  marginLeft: 16, borderRadius: 3, border:'1px solid #4f46e5' }} 
                 type="default" onClick={() => {window.open('/oam_task_edit?task_id=' + nodeTaskId)}}> 编 辑 </Button>
              </Col> }
              
            </Row>

            <Row gutter={[8, 8]} justify="start" align="top" style={{ marginBottom: 10 }}>
              <Col flex="100px" style={{ color: '#00000073', textAlign: 'left' }}>需要用户输入</Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
              <Switch checked={switchChecked} onChange={onSwitchChange} />
              </Col>
            </Row>

            <Row gutter={[8, 8]} justify="start" align="top" style={{ marginBottom: 10 }}>
              <Col flex="100px" style={{ color: '#00000073', textAlign: 'left' }}>输入引导</Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <TextArea disabled={!switchChecked} placeholder="请输入用户输入引导" style={{ borderRadius: 3, width: '100%' }} autoSize={{ minRows: 3, maxRows: 8 }} value={userInputGuide} onChange={(e) => { setUserInputGuide(e.target.value)}}/>
              </Col>
            </Row>

            <Row gutter={[8, 8]} justify="start" align="top" style={{ marginBottom: 10 }}>
              <Col flex="100px" style={{ color: '#00000073', textAlign: 'left' }}>参考答案</Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <TextArea  disabled={!switchChecked} placeholder="请输入参考答案" style={{ borderRadius: 3, width: '100%' }} autoSize={{ minRows: 3, maxRows: 8 }} value={userInputGuideAnswer} onChange={(e) => { setUserInputGuideAnswer(e.target.value)}}/>
              </Col>
            </Row>


            <Row gutter={[8, 8]} justify="start" align="top" style={{ marginBottom: 10 }}>
              <Col
                flex="100px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                节点说明
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
              <div className={myStyles.markDownEditorWrapper}>
                <MarkDownEditor
                  preview={false}
                  height={700}
                  placeholder="请输入节点说明内容"
                  onChange={onEditMDChange}
                  uploadOption={uploadOption}
                  value={description}
                  toolbar={'all'}
                />
              </div>

              </Col>
            </Row>

            <Row gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 10 }}
            >
              <Col span={24} style={{ textAlign: 'right' }}>
               {/* <span style={{ fontSize: 12, color: '#00000073' }}>
                  请上传以字母、数字命名的png,jepg,jpg,gif等格式的图片{' '}
                </span>
                <Upload {...uploadImageProps}>
                  <div>
                    <Button
                      size="small"
                      type="default"
                      style={{ width: 100, borderRadius: 20 }}
                    >
                      <UploadOutlined /> 传图
                    </Button>
                  </div>
                </Upload>
                 */}
              </Col>
            </Row>

            {/*<Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: images?.length > 0 ? 10 : 0 }}
            >
              <Col flex="100px"></Col>
              <Col
                flex="auto"
                style={{
                  borderRadius: 6,
                  borderStyle: 'dashed',
                  borderWidth: images?.length > 0 ? 1 : 0,
                  borderColor: '#e9e9e9',
                  textAlign: 'left',
                }}
              >
                <div style={{ marginTop: 10, marginBottom: 10 }}>
                  <ConfigProvider locale={zhCN}>
                    <Row justify="start" align="middle" gutter={[10, 10]}>
                      {images?.map((image: any) => {
                        return (
                          <Col key={image.name}>
                            <div>
                              <Popconfirm
                                placement="top"
                                title={'确认删除图片' + image.name + ' 吗？'}
                                okText="确认"
                                cancelText="取消"
                                onConfirm={(e) => {
                                  deleteImage(image.name, this)
                                }}
                                onCancel={() => {
                                  return
                                }}
                              >
                                <DeleteOutlined
                                  className={myStyles.iconbuttonsdel}
                                />
                              </Popconfirm>

                              <Image
                                width={360}
                                height={270}
                                src={constants.BACKEND_URL + image.url}
                              />
                            </div>
                          </Col>
                        )
                      })}
                    </Row>
                  </ConfigProvider>
                </div>

                <div className={'new-image'}></div>
                <div id={'add-image-div'}></div>
              </Col>
            </Row> */}


          </div>

          <ConfigProvider locale={zhCN}>
            <Modal
              title={
                <div
                  style={{
                    width: '100%',
                    cursor: 'move',
                  }}
                  onMouseOver={() => {
                    if (disabled) {
                      setDisabled(false)
                    }
                  }}
                  onMouseOut={() => {
                    setDisabled(true)
                  }}
                  onFocus={() => {}}
                  onBlur={() => {}}
                  // end
                >
                  选择任务
                </div>
              }
              closable={false}
              open={isAddTaskModalVisible}
              onOk={handleAddTaskOk}
              onCancel={handleAddTaskCancel}
              bodyStyle={{overflow: 'hidden' }}
              destroyOnClose={true}
              width={800}
              modalRender={(modal) => (
                <div className={myStyles.createDiv}>
                  <Draggable
                    disabled={disabled}
                    bounds={bounds}
                    onStart={(event, uiData) => onStart(event, uiData)}
                  >
                    <div ref={draggleRef}>{modal}</div>
                  </Draggable>{' '}
                </div>
              )}
            >
              <Input
                onPressEnter={onSearchTaskBtn}
                placeholder="搜索任务名称或ID"
                style={{
                  float: 'left',
                  borderRadius: 20,
                  width: 300,
                  marginBottom: 10,
                }}
                suffix={<SearchOutlined style={{ color: '#666666' }} />}
              />
              <div style={{height:500}} className={idataCodingTableStyles.tableWrapper}>
                <ConfigProvider locale={zhCN}>
                  <Table
                    dataSource={taskListResult}
                    columns={task_columns}
                    rowKey={(record) => record.id}
                    pagination={false}
                    size="small"
                    onChange={onTaskTableChange}
                    rowSelection={{
                      type: 'radio',
                      ...rowTaskSelection,
                    }}
                  />
                </ConfigProvider>
              </div>

              <ConfigProvider locale={zhCN}>
                <div
                  style={{
                    paddingTop: 20,
                    textAlign: 'center',
                  }}
                  className={'css.pagination'}
                >
                  <Pagination
                    defaultCurrent={1}
                    total={taskResultSum}
                    defaultPageSize={10}
                    hideOnSinglePage={true}
                    current={taskPage.current}
                    onChange={onTaskPageChange}
                    showTotal={(total) => `找到 ${total} 任务`}
                    showSizeChanger={false}
                  />
                </div>
              </ConfigProvider>
            </Modal>
          </ConfigProvider>
        </div>
      </Content>
    </Layout>
  )
}

export default OAMReportNodeEdit
